(() => {
  const getOffset = () => {
    const isMobile = window.matchMedia("(max-width: 989px)").matches;
    const sticky = document.getElementById("dmStickyAtc");
    const stickyH = sticky ? sticky.getBoundingClientRect().height : (isMobile ? 84 : 80);
    return stickyH + 16; // extra ruimte
  };

  const apply = () => {
    const offset = getOffset();

    // 1) iframe variant (jouw eerste outerHTML)
    document.querySelectorAll('iframe[title="chat widget"]').forEach((el) => {
      el.style.setProperty("bottom", offset + "px", "important");
      el.style.setProperty("right", "20px", "important"); // laat rechts staan
    });

    // 2) container variant (jouw tweede outerHTML)
    document.querySelectorAll(".tawk-min-container").forEach((el) => {
      el.style.setProperty("bottom", offset + "px", "important");
    });
  };

  // eerst meteen, dan nog een paar keer omdat Tawk vaak later overschrijft
  apply();
  window.addEventListener("resize", apply);

  let tries = 0;
  const iv = setInterval(() => {
    apply();
    tries += 1;
    if (tries > 30) clearInterval(iv); // ~15 sec
  }, 500);
})();